import React, { useState, useEffect, useContext } from "react";
import {
  Typography,
  Input,
  Button,
  Dropdown,
  Menu,
  Icon,
  message,
  Modal,
  Tabs,
} from "antd";

import { platformApi } from "../../../api";
import JobOrderTable from "./JobOrderTable";
import MechanicTable from "./MechanicTable";
import JobOrderModal from "./JobOrderModal";
import { ContextAPI } from "../../../ContextAPI";
import { useHistory, withRouter } from "react-router-dom";
import WrappedAdvancedFilter from "./AdvancedFilters";
import WrappedMechanicAssign from "./MechanicAssign";
import WrappedJobOrderLogs from "./JobOrderLog";
import WrappedVehicleForm from "../Vehicles/VehicleForm";
import WrappedVehicleInspection from "./VehicleInspection";
import WrappedOtpSend from "./OTP";
import { useLocation } from "react-router-dom";
const { TabPane } = Tabs;
const { Title } = Typography;
const { Search } = Input;
const { Item } = Menu;

const JobOrder = () => {
  const [limit, setLimit] = useState(10);
  const [addFlag, setAddFlag] = useState(false);
  const [change, setChange] = useState(false);
  const [editFlag, setEditFlag] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [redirectedData, setRedirectedData] = useState({});
  const [spinning, setSpinning] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(0);
  const [createAccess, setCreateAccess] = useState(false);
  const [modifyAccess, setModifyAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);
  const [printAccess, setPrintAccess] = useState(false);
  const { loginCredintials } = useContext(ContextAPI);
  const isMechanic = loginCredintials.role === "Mechanic";
  const [tab, setTab] = useState(isMechanic ? "Work In Progress" : "Vehicle Received");
  const [active, setActive] = useState(isMechanic ? "4" : "1");

  const [filterData, setFilterData] = useState({
    model: null,
    serviceType: null,
    mechanic: [],
    registerNo: null,
    kms: null,
    jobCardCreationDate: null,
    jobStatus: null,
  });
  const [filteropen, setFilteropen] = useState(false);
  const [filter, setFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const [branch, setBranch] = useState([]);
  const [mechanic, setMechanic] = useState([]);
  const [assign, setAssign] = useState(false);
  const [assignData, setAssignData] = useState(-1);
  const [log, setLog] = useState(false);
  const [logData, setLogData] = useState(-1);
  const [vOpen, setVOpen] = useState(false);
  const [vData, setVData] = useState(-1);
  const [insp, setInsp] = useState(false);
  const [statusData, setStatusData] = useState(-1);
  const [otp, setOtp] = useState(false);
  const [otpData, setOtpData] = useState(-1);
  const [referenceid, setReferenceId] = useState("");
  const [gst, setGst] = useState();
  const location = useLocation();
  const isDisable = isMechanic;

  const getMenu = () => {
    const size = count / 10 + (count % 10) ? 1 : 0;
    const menus = [];
    menus.push(10);
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Item onClick={() => setLimit(menu)} key={menu}>
        {menu}
      </Item>
    ));
  };

  useEffect(() => {
    if (isMechanic) {
      setPrimaryData("", "Work In Progress");
    }
  }, []);

  useEffect(() => {
    let temp = [];
    setGst(loginCredintials.branch[0].gst);
    loginCredintials.roleAccess &&
      loginCredintials.roleAccess?.map((each) => {
        if (each.subModule === "job_order") {
          if (each.access.create) {
            setCreateAccess(true);
          }
          if (each.access.update) {
            setModifyAccess(true);
          }
          if (each.access.delete) {
            setDeleteAccess(true);
          }
          if (each.access.print) {
            setPrintAccess(true);
          }
        }
      });
    for (let i = 0; i < loginCredintials.branch.length; i++) {
      const element = loginCredintials.branch[i];
      temp.push(element.id);
    }
    setBranch(temp);
    if (temp && temp.length > 0) setPrimaryData(search);
    getMechanic();
  }, []);

  const getMechanic = () => {
    platformApi.get("/api/user").then((result) => {
      let { data } = result;
      if (data.code === 200) {
        let mechanic = data.data.users.filter((item) => {
          return item.profile && item.profile.department && item.profile.department.role === "Mechanic";
        });
        setMechanic(mechanic);
      }
    });
  };

  useEffect(() => {
    if (branch && branch.length > 0) setPrimaryData(search);
  }, [page, limit, search, branch, filterData]);

  useEffect(() => {
    const jobOrderState = localStorage.getItem("jobOrderState");

    if (jobOrderState && dataSource.length > 0) {
      const { jobId } = JSON.parse(jobOrderState);

      openModal(jobId, true, true);

      // Clean up after use
      localStorage.removeItem("jobOrderState");
    }
  }, [dataSource]);

  const TableComponent = isMechanic ? MechanicTable : JobOrderTable;

  const setPrimaryData = (search, status, val) => {
    if (!status) {
      status = tab;
    }
    setSpinning(true);

    let obj = {
      page: val ? val : page,
      size: limit,
      filter: {
        ...filterData,
        mechanic: filterData.mechanic || [],
      },
      searchString: search,
      status,
      branch: branch && branch,
    };

    if (isDisable) {
      const mechanicId = loginCredintials.employeeId || loginCredintials.id || loginCredintials._id;
      obj.filter.mechanic = mechanicId ? [mechanicId] : [];
    }
    platformApi
      .post("/api/jobOrder/get", obj)
      .then((res) => {
        setSpinning(false);
        let { data } = res;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            // setDataSource(response.data.jobOrder);
            setDataSource(
              response.data.jobOrder.map((item, index) => ({
                ...item,
                key: item.id != null ? item.id.toString() : `job-${index}`  // 👈 Ensure each row has a unique key
              }))
            );
            setCount(response.data.count);
          } else {
            message.error("Failed to fetch Job Order");
          }
        } else {
          message.error("Failed to fetch Job Order");
        }
      })
      .catch((error) => {
        setSpinning(false);
        console.error("Error on Job Order : ", error);
        message.error("Failed to fetch Job Order");
      });
  };

  const deleteData = (id) => {
    setSpinning(true);
    let temp = page != 1 && dataSource.length === 1;
    // if (page != 1 && dataSource.length === 1) {
    //   setPage(page - 1)
    // }
    platformApi
      .delete("/api/jobOrder/" + id)
      .then((result) => {
        setSpinning(false);
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            if (temp) {
              setPage(1);
              setPrimaryData(null, null, 1);
            } else {
              setPrimaryData();
            }
            message.success("Deleted Sucessfully", 2);
          } else {
            message.error("Unable to delete Job Order", 2);
          }
        } else {
          message.error("Unable to delete Job Order", 2);
        }
      })
      .catch((error) => {
        setSpinning(false);
        console.error("Error on Job Order : ", error);
        message.error("Unable to delete Job Order", 2);
      });
  };

  const addData = (jobOrder) => {
    setSpinning(true);
    if (jobOrder.id) {
      platformApi
        .put(`/api/jobOrder/${jobOrder.id}`, jobOrder)
        .then((res) => {
          setSpinning(false);
          let { data } = res;
          if (data.code === 200) {
            let { response } = data;
            if (response.code === 200) {
              const updated = dataSource.map((obj) =>
                obj.id === jobOrder.id
                  ? {
                      ...response.data,
                      key: response.data.id != null ? response.data.id.toString() : obj.key,
                    }
                  : obj
              );
              setDataSource(updated);
              setPrimaryData(search, tab);
              message.success("Job Order Updated successfully", 2);
            } else {
              message.error("Unable to update Job Order", 2);
            }
          } else {
            message.error("Unable to update Job Order", 2);
          }
        })
        .catch((err) => {
          setSpinning(false);
          message.error("Unable to update Job Order", 2);
          console.error("Error on Job Order : ", err);
        });
    } else
      platformApi
        .post("/api/jobOrder/", jobOrder)
        .then((res) => {
          setSpinning(false);
          const data = res?.data || {};
          const response = data.response || {};
          // Prefer nested service code (works whether outer HTTP wrapper is 200 or 400)
          const apiCode =
            response.code !== undefined && response.code !== null
              ? response.code
              : data.code;
          const apiMessage =
            response.message ||
            data.message ||
            data.msg ||
            "Unable to create Job Card.";

          if (apiCode === 200) {
            setDataSource([...dataSource, response.data]);
            setCount(count + 1);
            message.success("Job Order added successfully");
            setPrimaryData(null, tab);
          } else {
            Modal.warning({
              title: "Cannot Create Job Card",
              content:
                apiMessage ||
                "A Job Card already exists for this vehicle with the same Service Type and KMs.",
              okText: "OK",
            });
          }
        })
        .catch((err) => {
          setSpinning(false);
          const errData = err?.response?.data || {};
          const errMsg =
            errData?.response?.message ||
            errData?.message ||
            errData?.msg ||
            "Unable to create Job Card.";
          Modal.warning({
            title: "Cannot Create Job Card",
            content: errMsg,
            okText: "OK",
          });
          console.error("Error on Job Order : ", err);
        });
  };

  const handleTabChange = (activeKey) => {
    switch (activeKey) {
      case "1":
        setPrimaryData(search, "Vehicle Received");
        setTab("Vehicle Received");
        setPage(1);
        setActive("1");
        break;
      case "2":
        setPrimaryData(search, "Claim Intimated");
        setTab("Claim Intimated");
        setPage(1);
        setActive("2");
        break;
      case "3":
        setPrimaryData(search, "Spares Ordered");
        setTab("Spares Ordered");
        setPage(1);
        setActive("3");
        break;
      case "4":
        setPrimaryData(search, "Work In Progress");
        setTab("Work In Progress");
        setPage(1);
        setActive("4");
        break;
      case "5":
        setPrimaryData(search, "Work Completed");
        setTab("Work Completed");
        setPage(1);
        setActive("5");
        break;
      case "6":
        setPrimaryData(search, "Ready for Delivery");
        setTab("Ready for Delivery");
        setPage(1);
        setActive("6");
        break;
      case "7":
        setPrimaryData(search, "Feedback Call");
        setTab("Feedback Call");
        setPage(1);
        setActive("7");
        break;
      case "8":
        setPrimaryData(search, "ALL");
        setTab("ALL");
        setPage(1);
        setActive("8");
        break;
      default:
        setPrimaryData(search, null);
        setTab("ALL");
        setPage(1);
        setActive("8");
    }
  };

  const collapseFilter = () => {
    if (filteropen) {
      setFilteropen(false);
      setFilterData({});
    } else {
      setFilteropen(true);
    }
    setSearch("");
  };

  const tabPanes = [
    {
      key: "1",
      label: "Vehicle Received",
      show: !isMechanic,
      props: { setAssign, setAssignData, setOtp, setOtpData, setReferenceId, gst }
    },
    {
      key: "2",
      label: "Claim Intimated",
      show: !isMechanic,
      props: { setAssign, setAssignData }
    },
    {
      key: "3",
      label: "Spares Ordered",
      show: !isMechanic,
      props: { setAssign, setAssignData }
    },
    {
      key: "4",
      label: "Work In Progress",
      show: true,
      props: { setAssign, setAssignData }
    },
    {
      key: "5",
      label: "Work Completed",
      show: !isMechanic,
      props: { isCompletedTab: true }
    },
    {
      key: "6",
      label: "Ready for Delivery",
      show: !isMechanic,
      props: { setAssign, setAssignData }
    },
    {
      key: "7",
      label: "Feedback Call",
      show: !isMechanic,
      props: { isCompletedTab: true }
    },
    {
      key: "8",
      label: "All",
      show: !isMechanic,
      props: { setAssign, setAssignData, gst }
    }
  ];

  const openModal = (id, editable, change) => {
    setEditFlag(editable);
    setChange(change);
    getJob(id);
    setAddFlag(true);
  };

  const commonTableProps = {
    pagination: {
      onChange: (page) => setPage(page),
      pageSize: limit,
      defaultCurrent: 1,
      total: count,
      showQuickJumper: true,
    },
    openModal,
    delete: (id) => deleteData(id),
    dataSource,
    spinner: spinning,
    modify: modifyAccess,
    setLogData,
    setLog,
    setInsp,
    setStatusData,
    deleteAccess,
    printAccess,
    setPageData: (searchVal, statusVal, pageVal) => setPrimaryData(searchVal, statusVal, pageVal),
    onTabSwitch: (key) => handleTabChange(key),
  };

  const getJob = (id) => {
    platformApi.get(`api/jobOrder/${id}`).then((res) => {
      if (!res.data.response.data) {
        message.info("Job with this ID is not found in Database")
      }
      setRedirectedData(res.data.response.data);
    })
  }

  const menu = <Menu>{getMenu()}</Menu>;
  return (
    <div>
      <div className="accessories-head">
        <Title style={{ width: "60%" }} level={4}>
          Job Card [{count}]
          <span style={{ margin: ".5rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit} &nbsp;
                <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <Search
          style={{ width: "30%" }}
          placeholder="Search Job Order"
          onSearch={(event) => {
            setPage(1);
            setSearch(event);
          }}
          onChange={(event) => {
            if (event.target.value === "") {
              setSearch(null);
              setPage(1);
            }
          }}
        />
        <div style={{ width: "12%", textAlign: "center", marginLeft: "1%" }}>
          <Button
            type="link"
            onClick={() => {
              collapseFilter();
            }}
          >
            {filteropen ? "Back" : "Advanced  Filters"}
          </Button>
        </div>
        <Button
          onClick={() => {
            setAddFlag(true);
            setEditFlag(true);
          }}
          style={{ margin: "0 3%", width: "20%" }}
          type="primary"
          disabled={!createAccess}
        >
          Add Job Card
        </Button>
      </div>
      <WrappedAdvancedFilter
        filteropen={filteropen}
        searchName={search}
        setId={setFilter}
        setPageData={setPrimaryData}
        setSearch={setSearch}
        setFilterData={setFilterData}
        setPage={setPage}
        disabled={!createAccess}
      />

      <Tabs activeKey={active} onChange={handleTabChange}>
        {tabPanes.map(({ key, label, show, props }) =>
          show && (
            <TabPane tab={<span>{label}</span>} key={key}>
              <TableComponent
                {...commonTableProps}
                {...props}
              />
            </TabPane>
          )
        )}
      </Tabs>


      <JobOrderModal
        data={redirectedData}
        emitData={(data) => addData(data)}
        editable={editFlag}
        changed={change}
        setChange={setChange}
        setEditFlag={setEditFlag}
        modify={modifyAccess}
        loading={loading}
        setLoading={setLoading}
        open={addFlag}
        close={() => {
          setAddFlag(false);
          setLoading(false);
          setRedirectedData({});
          setChange(false)
        }}
      />{" "}

      <WrappedMechanicAssign
        data={dataSource[dataSource.findIndex((obj) => assignData === obj.id)]}
        modify={modifyAccess}
        open={assign}
        close={() => {
          setAssign(false)
          setAssignData(null);
          setPrimaryData();
        }}
        editable={true}
        mechanic={mechanic}
        setMechanic={setMechanic}
      />

      <WrappedJobOrderLogs
        data={dataSource[dataSource.findIndex((obj) => logData === obj.id)]}
        modify={modifyAccess}
        open={log}
        close={() => {
          setLog(false)
          setLogData(null);
          setPrimaryData();
        }}
        editable={true}
        setVData={setVData}
        setVOpen={setVOpen}
      />

      <WrappedVehicleInspection
        data={dataSource[dataSource.findIndex((obj) => statusData === obj.id)]}
        modify={modifyAccess}
        open={insp}
        close={() => {
          setInsp(false)
          setStatusData(null);
          setPrimaryData();
        }}
        editable={true}
      />

      <WrappedVehicleForm
        data={vData}
        // emitData={addData}
        vData={true}
        open={vOpen}
        editable={false}
        close={() => {
          setVOpen(false);
          setPrimaryData();
        }}
        modify={modifyAccess}
        edit={vOpen}
        setEdit={setVOpen}
      />

      <WrappedOtpSend
        data={dataSource[dataSource.findIndex((obj) => otpData === obj.id)]}
        modify={modifyAccess}
        open={otp}
        close={() => {
          setOtp(false)
          setOtpData(null);
          setPrimaryData();
        }}
        editable={true}
        referenceid={referenceid}
      />

    </div>
  );
}
export default withRouter(JobOrder);